import useDebounceCallback from 'hooks/useDebounceCallback'
import { useEffect } from 'react'
import { calculateScrollbarWidth } from 'utils/scroll'

export const useInitialScrollbarWidth = () => {
  const debounce = useDebounceCallback()

  calculateScrollbarWidth()

  useEffect(() => {
    const debouncedCalculateScrollbarWidth = () => {
      debounce(() => calculateScrollbarWidth(), 100)
    }

    window.addEventListener('resize', debouncedCalculateScrollbarWidth)

    return () => {
      window.removeEventListener('resize', debouncedCalculateScrollbarWidth)
    }
  }, [debounce])
}
